import { confirmSignIn, signIn } from "@aws-amplify/auth";
import * as msal from "@azure/msal-browser";

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const msalConfig = (msalClientId: string) => {
  if (!msalClientId) {
    throw new Error(
      "MSAL client ID is not configured. Please set the MSAL_CLIENT_ID environment variable.",
    );
  }

  return {
    auth: {
      clientId: msalClientId,
    },
  };
};

const msalConfigTemp = (msalClientId: string) => ({
  auth: {
    ...msalConfig(msalClientId).auth,
    onRedirectNavigate: () => {
      // Return false if you would like to stop navigation after local logout
      return false;
    },
  },
});

export const msalSignOut = async (msalClientId: string) => {
  if (!msalClientId) {
    return;
  }
  const msalInstanceTemp = new msal.PublicClientApplication(
    msalConfigTemp(msalClientId),
  );
  await msalInstanceTemp.initialize();
  await msalInstanceTemp.logoutRedirect();
};

export const authenticateWithMicrosoftToken = async (
  account: msal.AccountInfo,
) => {
  const userName: string =
    (account.idTokenClaims?.email as string)?.toLowerCase() ?? "";
  if (!userName) {
    throw new Error("No email from Microsoft found.");
  }
  const signInOutput = await signIn({
    username: userName,
    options: { authFlowType: "CUSTOM_WITHOUT_SRP" },
  });

  if (
    signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
  ) {
    throw new Error(`Unexpected challenge name: Expected CUSTOM_CHALLENGE.`);
  }

  if (!account.idToken) {
    throw new Error("No idToken found in MSAL account");
  }

  // after sign in is started we need to continue with authentication and we sent microsoft token
  await confirmSignIn({ challengeResponse: account.idToken });

  return;
};
